<template>
  <div>
    <div aria-hidden="true" class="modal fade" id="modalCambiarcosto" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-lg custom-modal-extendido">
        <div class="modal-content custom-modal-extendido">
          <div class="modal-header faded">
            <h5 class="modal-title">Edición Precios de Compra</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="costodata.producto != null">
            <form @submit.prevent="proyectarPrecios">
              <div class="row">
                <div class="col-12">
                  <h5>
                    {{ costodata.producto_obj.sku }} -
                    {{ costodata.producto_obj.nombre }}
                  </h5>
                </div>
              </div>
              <div class="row align-items-center">
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="costo_actual">Costo Actual</label>
                    <div>
                      <input id="costo_actual" ref="costo_actual" class="form-control" placeholder="Costo Actual"
                        type="text" :value="costoRedondeado" disabled>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="costo_nuevo">Nuevo Costo</label>
                    <div>
                      <input id="costo_nuevo" ref="costo_nuevo" class="form-control" placeholder="Q. 0.00" type="text">
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="margen">Margen</label>
                    <div>
                      <input id="margen" ref="margen" class="form-control" placeholder="%" type="text">
                    </div>
                  </div>
                </div>
                <div class="col-md-3 d-flex align-items-end">
                  <div class="form-group mb-0">
                    <button type="submit" class="btn btn-dark mt-2" @mouseover="startRotation"
                      @mouseout="stopRotation">Proyectar Precios <i class="os-icon os-icon-sun"
                        :class="{ 'rotating-icon': isHovering }"></i></button> &nbsp;
                  </div>
                  <button class="btn btn-dark mt-2" @click="Limpiar()"><i class="fas fa-undo"></i></button>
                </div>
              </div>
            </form>
            <div class="row" v-if="tablaVisible">
              <div class="col-12">
                <div class="table-responsive" v-if="precios.length > 0">
                  <table class="table table-bordered table-lg table-v2 table-striped overflow-auto">
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th colspan="2">Actual</th>
                        <th colspan="2">Nuevo</th>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <th>Lista</th>
                        <th>Unidades</th>
                        <th>Tipo</th>
                        <th>Margen</th>
                        <th>Margen Real</th>

                        <th>Costo</th>
                        <th>Venta</th>
                        <th>Costo</th>
                        <th>Venta</th>
                        <th>Diferencia</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="precio in precios" :key="precio.id"
                        v-if="precio.lista_precio_id !== 5 && precio.lista_precio_id !== 13">
                        <td class="nowrap">
                          {{ precio.nombre }}
                        </td>
                        <td>
                          {{ precio.cantidad_unidades }}
                        </td>
                        <td class="text-right">{{ precio.tipo_calculo }}</td>
                        <td class="text-right">{{ precio.margen }}</td>
                        <td class="text-right">{{ precio.margen }}</td>
                        <td class="text-right">Q {{ costoRedondeado }}</td>
                        <td class="text-right">Q {{ precio.precio }}</td>
                        <td class="text-right">Q {{ precio.costo }}</td>
                        <td class="text-right">
                          <span v-if="precio.precio_nuevo > precio.precio" class="text-success">Q {{ precio.precio_nuevo
                            }}</span>
                          <span v-if="precio.precio_nuevo <= precio.precio" class="text-danger">Q {{ precio.precio_nuevo
                            }}</span>
                        </td>
                        <td class="text-right">
                          <span v-if="precio.precio_nuevo > precio.precio" class="text-success">+ {{ precio.diferencia
                            }}</span>
                          <span v-if="precio.precio_nuevo <= precio.precio" class="text-danger">{{ precio.diferencia
                            }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" v-if="precios.length > 0">
            <button class="btn btn-outline-dark mr-auto" @click="irAprecios">
              <i class="os-icon os-icon-chevrons-left sliding-icon"></i>
              Ir a precios de venta
            </button>
            <button class="btn btn-danger" type="button" @click="cambiarCosto">
              Cambiar Costo
            </button>
            <button class="btn btn-primary" type="button" @click="cambiarCostoYPrecios">
              Cambiar Costo y Cambiar Precios
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  data() {
    return {
      errors: {},
      precios: [],
      isHovering: false,
      tablaVisible: false,
      nuevoCosto: "",
      margen: "",
    };
  },
  props: {
    costodata: {
      type: Object,
      required: true,
      default: {
        id: null,
        producto: null,
        producto_obj: {},
      },
    },
  },
  watch: {},
  computed: {
    costoRedondeado() {
      return parseFloat(this.costodata.costo).toFixed(2);
    },
  },
  mounted() {
    let self = this;
    $("#modalCambiarcosto").on("hidden.bs.modal", function (e) {
      self.precios = [];
    });
  },
  methods: {
    startRotation() {
      this.isHovering = true;
    },
    stopRotation() {
      this.isHovering = false;
    },
    irAprecios() {
      this.$router.push({
        name: "cat-productos-precios",
        params: { sku: this.costodata.producto_obj.sku },
      });
      $("#modalCambiarcosto").modal("hide");
    },
    proyectarPrecios() {
      let self = this;
      DynamicService.getAction(
        "cat",
        "productos",
        self.costodata.producto,
        "proyeccion_precios_cambio_costo",
        {
          nuevo_costo: self.costodata.costo,
        }
      )
        .then((res) => {
          self.precios = res.data;
          self.tablaVisible = self.precios.length > 0;
          console.log(res.data);
          self.errors = "";
        })
        .catch((error) => {
          self.errors = error.response.data;
          Notifications.alert.error(
            "Proyectar Precios",
            error.response.data.detail
          );
        });
    },
    cambiarCosto() {
      let self = this;
      let params = self.costodata;
      delete params.otros_costos;
      delete params.id;
      params.actualizar_precios = false;
      DynamicService.save("cat", "producto-costo", params)
        .then((res) => {
          Notifications.alert.success(
            "Cambiar Precio de Costo",
            "Realizado satisfactoriamente"
          );
        })
        .catch((err) => {
          Notifications.alert.error(
            "Cambiar Precio de Costo",
            err.response.data.costo[0]
          );
        });
    },
    cambiarCostoYPrecios() {
      let self = this;
      let params = self.costodata;
      delete params.otros_costos;
      delete params.id;
      params.actualizar_precios = true;
      DynamicService.save("cat", "producto-costo", params)
        .then((res) => {
          Notifications.alert.success(
            "Cambiar Precio de Costo",
            "Realizado satisfactoriamente"
          );
          console.log(res.data);
          self.proyectarPrecios();
        })
        .catch((err) => {
          Notifications.alert.error(
            "Cambiar Precio de Costo",
            err.response.data.costo[0]
          );
        });
    },
    Limpiar() {
      this.$refs.costo_nuevo.value = "";
      this.$refs.margen.value = "";
      this.tablaVisible = false;
      this.precios = [];
    },
  },
};
</script>
<style>
.jumping-icon {
  animation: jump 0.8s ease-in-out infinite alternate;
}

@keyframes jump {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-2px);
  }

  100% {
    transform: translateY(0);
  }
}

.sliding-icon {
  animation: slide 0.8s ease-in-out infinite alternate;
}

@keyframes slide {
  0% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(-2px);
  }

  100% {
    transform: translateX(0);
  }
}

.rotating-icon {
  animation: rotate 10s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.custom-modal-extendido {
  max-width: 1100px;
  width: 100%;
  margin: auto;
}
</style>
